import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CodeConversionMstDto, Sgke041aRequest, Sgke041aResponseResponseBusinessArea, Sgke042aRequest, Sgke043aRequest } from 'sg-api';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { UsedSgke041aService } from '../../services/used-sgke041a.service';
import { UsedSgke042aService } from '../../services/used-sgke042a.service';
import { UsedSgke043aService } from '../../services/used-sgke043a.service';

/**
 * 振替登録画面ビュー
 * @export
 * @class Sgke040dViewComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'app-sgke040d-view',
  templateUrl: './sgke040d-view.component.html',
  styleUrl: './sgke040d-view.component.scss'
})
export class Sgke040dViewComponent implements OnInit, OnDestroy {

  /** 請求お客さま番号 */
  // @Input() recptFixNo: string;

  /** 未精算金管理番号 */
  @Input() kinkoMno: string;
  /** 未精算金履歴番号 */
  @Input() kinkoRrkno: string;
  /** 未精算金_更新通番号 */
  @Input() kinkoUpdateSrno: string;
  /** 未精算金EX_更新通番号 */
  @Input() kinkoexUpdatesequencenumber: string;

  /** メッセージエミッター */
  @Output() msgEmit = new EventEmitter();
  /** エラーメッセージエミッター */
  @Output() errorMessageEmit = new EventEmitter();
  /** 通常メッセージエミッター */
  @Output() normalMessageEmit = new EventEmitter();
  /** メッセージエリアクリアエミッター */
  @Output() clearMessageEmit = new EventEmitter();
  /** SGKE020D再描画（再検索）エミッター */
  @Output() searchEmit = new EventEmitter();

  /** 検索結果リスト */
  searchResultList: Array<Sgke041aResponseResponseBusinessArea> = new Array<Sgke041aResponseResponseBusinessArea>();
  /** コード変換マスタマップ */
  codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;

  /** 振替先検索APIリクエスト */
  private request: Sgke041aRequest;
  /** 振替先登録APIリクエスト */
  private request042a: Sgke042aRequest;
  /** 振替登録（CIS対象外）APIリクエスト */
  private request043a: Sgke043aRequest;

  /** 預り金の振替先請求情報FormGroup */
  azukarikinFurikaeSearchConditionForm: UntypedFormGroup;

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /**
   * コンストラクタ
   * @param {UntypedFormBuilder} fb
   * @param {UsedSgke041aService} searchService
   * @param {UsedSgke042aService} registService
   * @param {UsedSgke043aService} registNonCisService
   * @memberof Sgke040dViewComponent
   */
  constructor(private fb: UntypedFormBuilder,
    public searchService: UsedSgke041aService,
    public registService: UsedSgke042aService,
    public registNonCisService: UsedSgke043aService,
    private codeConversionMstService: CodeConversionMstService
  ) {

    // 預り金の振替先請求情報FormGroup
    this.azukarikinFurikaeSearchConditionForm = this.fb.group({
      requestCommon: new UntypedFormGroup({}),
    });
  }

  /**
   * 初期処理
   * @memberof Sgke040dViewComponent
   */
  ngOnInit(): void {
    // コード変換マスタ取得
    this.codeConversionMstService.getCodeConversionMst(['S300980'])
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(data => {
        // ローカルに保存
        this.codeConversionMstMap = data;
      });
  }

  /**
   * 購読解除
   * @memberof Sgke040dViewComponent
   */
  ngOnDestroy() {
    this.onDestroy$.next();
  }

  /**
   * 請求お客様情報検索API呼出し
   * @memberof Sgke040dViewComponent
   */
  onSearchFurikaesaki(recptFixNo: string): void {

    // searchResult初期化
    this.searchResultList.length = 0;

    // リクエスト情報をもつオブジェクトを定義
    this.request = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      reqBusinessArea: {
        recptFixNo: recptFixNo
      }
    };

    this.searchService.doSgke041a(this.request).subscribe(
      response => {
        this.searchResultList.length = 0;
        if (response?.responseBusinessArea) {
          this.searchResultList.push(response.responseBusinessArea);
        }

        // メッセージを表示
        if (response?.responseCommon?.errors?.length > 0) {
          this.msgEmit.emit(response?.responseCommon?.errors);
        }

      },
      error => {
      }
    );
  }

  /**
   * 振替登録API呼出し
   *
   * @param {string} event
   * @memberof Sgke040dViewComponent
   */
  onClickRegist(event: string,): void {

    this.clearMessageEmit.emit();

    // リクエスト情報をもつオブジェクトを定義
    this.request042a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      regCndt: {
        furikaeInfo: {
          kinkoMno: this.kinkoMno,
          kinkoRrkno: this.kinkoRrkno,
          kinkoUpdateSrno: this.kinkoUpdateSrno,
          kinkoexUpdatesequencenumber: this.kinkoexUpdatesequencenumber,
          claimVisitornumberTransferdestination: event
        }
      }
    };

    this.registService.doSgke042a(this.request042a).subscribe(
      response => {
        if (response) {
          // メッセージを表示
          if (response?.responseCommon?.errors?.length > 0) {
            this.msgEmit.emit(response?.responseCommon?.errors);
          }

          // SGKE020D_未精算整理詳細画面の再描画
          this.searchEmit.emit();
        }
      },
      error => {
      }
    );
  }

  /**
   * 振替登録（CIS外）API呼出し
   * @param {string} event
   * @memberof Sgke040dViewComponent
   */
  onClickRegistNonCis(): void {

    this.clearMessageEmit.emit();

    // リクエスト情報をもつオブジェクトを定義
    this.request043a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      regCndt: {
        furikaeInfo: {
          kinkoMno: this.kinkoMno,
          kinkoRrkno: this.kinkoRrkno,
          kinkoUpdateSrno: this.kinkoUpdateSrno,
          kinkoexUpdatesequencenumber: this.kinkoexUpdatesequencenumber,
        }
      }
    };

    this.registNonCisService.doSgke043a(this.request043a).subscribe(
      response => {
        if (response) {
          // メッセージを表示
          if (response?.responseCommon?.errors?.length > 0) {
            this.msgEmit.emit(response?.responseCommon?.errors);
          }

          // SGKE020D_未精算整理詳細画面の再描画
          this.searchEmit.emit();
        }
      },
      error => {
      }
    );
  }

  /**
   * 検索フラグ初期化処理
   * @memberof Sgke040dViewComponent
   */
  hideazukarikinFurikaesakiSearched(): void {
    this.searchResultList.length = 0;
  }

}